import { createElement } from 'react';
import { TURNOVER_NOTICE_CLOSE_LABEL, TURNOVER_NOTICE_MESSAGE } from './helpers.js';

export function TurnoverNoticePopup({
  message = TURNOVER_NOTICE_MESSAGE,
  closeLabel = TURNOVER_NOTICE_CLOSE_LABEL,
  onClose,
}) {
  return createElement(
    'div',
    {
      className: 'turnover-notice-popup',
      role: 'presentation',
    },
    createElement(
      'div',
      {
        className: 'turnover-notice-popup-card',
        role: 'dialog',
        'aria-modal': 'true',
        'aria-label': message,
      },
      createElement(
        'button',
        {
          type: 'button',
          className: 'turnover-notice-popup-close',
          'aria-label': closeLabel,
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();
            onClose?.();
          },
        },
        '✕'
      ),
      createElement('p', { className: 'turnover-notice-popup-message' }, message)
    )
  );
}
